<ng-container *transloco="let t; read: 'absenceGroups'">
  <button
    *ngIf="('Permissions.AbsenceGroups.Create' | permission)"
    kendoButton
    fillMode="solid"
    size="medium"
    rounded="medium"
    themeColor="primary"
    type="button"
    (click)="openCreate()"
    class="mbm"
  >
    {{ t("recordAbsence") }}
  </button>

  <!-- Without the list right there is nothing to switch between: the calendar stands alone. -->
  <div class="mbm align-right" *ngIf="canViewList">
    <kendo-buttongroup [selection]="'single'">
      <button
        kendoButton
        [selected]="viewMode === 'list'"
        [toggleable]="true"
        (click)="onViewModeChange('list')"
      >
        {{ t('listView') }}
      </button>
      <button
        *ngIf="('Permissions.Ressources.Search' | permission)"
        kendoButton
        [selected]="viewMode === 'calendar'"
        [toggleable]="true"
        (click)="onViewModeChange('calendar')"
      >
        {{ t('calendarView') }}
      </button>
    </kendo-buttongroup>
  </div>

  <ng-container *ngIf="viewMode === 'list' && canViewList">
    <h3 class="mtm">{{ t("filter") }}</h3>
    <form
      [formGroup]="filterForm"
      (ngSubmit)="onFilter()"
      class="grid col3 mbm mts"
    >
      <kendo-formfield>
        <kendo-label [text]="t('from')"></kendo-label>
        <kendo-datepicker formControlName="from">
          <kendo-datepicker-messages
            [today]="t('today')"
          ></kendo-datepicker-messages>
        </kendo-datepicker>
      </kendo-formfield>

      <kendo-formfield>
        <kendo-label [text]="t('to')"></kendo-label>
        <kendo-datepicker formControlName="to">
          <kendo-datepicker-messages
            [today]="t('today')"
          ></kendo-datepicker-messages>
        </kendo-datepicker>
      </kendo-formfield>

      <kendo-formfield>
        <kendo-label [text]="t('onlyUnsigned')"></kendo-label>
        <kendo-switch
          formControlName="onlyUnsigned"
          [onLabel]="t('switch.true')"
          [offLabel]="t('switch.false')"
        ></kendo-switch>
      </kendo-formfield>

      <kendo-formfield>
        <kendo-label for="searchEmployee" [text]="t('employee') + ' *'"></kendo-label>
        <kendo-dropdownlist
          [data]="employees$ | async"
          [defaultItem]="defaultEmployee"
          textField="name"
          valueField="id"
          [valuePrimitive]="true"
          formControlName="employeeId"
          id="searchEmployee"
        >
          <ng-template kendoDropDownListItemTemplate let-dataItem>
            {{ dataItem.firstName }} {{ dataItem.lastName }}
          </ng-template>
          <ng-template kendoDropDownListValueTemplate let-dataItem>
            {{ dataItem?.firstName }} {{ dataItem?.lastName }}
          </ng-template>
        </kendo-dropdownlist>
      </kendo-formfield>

      <kendo-formfield>
        <kendo-label [text]="t('absenceType') + ' *'"></kendo-label>
        <kendo-dropdownlist
          [data]="absenceTypes$ | async"
          [defaultItem]="defaultAbsence"
          textField="name"
          valueField="id"
          [valuePrimitive]="true"
          formControlName="absenceType"
        ></kendo-dropdownlist>
      </kendo-formfield>

      <kendo-formfield>
        <kendo-label [text]="t('absenceState') + ' *'"></kendo-label>
        <kendo-dropdownlist
          [data]="absenceStatesArray"
          [defaultItem]="defaultAbsence"
          textField="name"
          valueField="id"
          [valuePrimitive]="true"
          formControlName="absenceState"
        ></kendo-dropdownlist>
      </kendo-formfield>

      <button
        kendoButton
        fillMode="solid"
        size="medium"
        rounded="medium"
        themeColor="primary"
        type="submit"
        class="mrs"
        loadingIndication="/AbsenceGroup/searchAbsenceGroup"
      >
        {{ t("search") }}
      </button>

      <button
        *ngIf="filterForm.dirty"
        kendoButton
        fillMode="outline"
        size="medium"
        rounded="medium"
        themeColor="primary"
        type="button"
        (click)="onResetFilter()"
        class="mrs"
      >
        {{ t("reset") }}
      </button>
    </form>

    <app-absence-group-grid [isAdminView]="true"></app-absence-group-grid>
  </ng-container>

  <app-absence-scheduler
    *ngIf="viewMode === 'calendar' && ('Permissions.Ressources.Search' | permission)"
  ></app-absence-scheduler>

  <kendo-dialog
    *ngIf="createOpen"
    [title]="t('recordTitle')"
    (close)="closeCreate()"
    [width]="700"
  >
    <form [formGroup]="createAbsenceForm" (ngSubmit)="onCreateAbsence()" class="grid col2">
      <kendo-formfield>
        <kendo-label [text]="t('dateFrom')"></kendo-label>
        <kendo-datepicker formControlName="dateFrom">
          <kendo-datepicker-messages
            [today]="t('today')"
          ></kendo-datepicker-messages>
        </kendo-datepicker>
      </kendo-formfield>

      <kendo-formfield>
        <kendo-label [text]="t('isHalfDayEnd')"></kendo-label>
        <kendo-switch
          formControlName="isHalfDayEnd"
          [onLabel]="t('switch.true')"
          [offLabel]="t('switch.false')"
        ></kendo-switch>
      </kendo-formfield>

      <kendo-formfield>
        <kendo-label [text]="t('dateTo')"></kendo-label>
        <kendo-datepicker formControlName="dateTo">
          <kendo-datepicker-messages
            [today]="t('today')"
          ></kendo-datepicker-messages>
        </kendo-datepicker>
      </kendo-formfield>

      <kendo-formfield>
        <kendo-label [text]="t('isHalfDayStart')"></kendo-label>
        <kendo-switch
          formControlName="isHalfDayStart"
          [onLabel]="t('switch.true')"
          [offLabel]="t('switch.false')"
        ></kendo-switch>
      </kendo-formfield>

      <kendo-formfield>
        <kendo-label [text]="t('title')"></kendo-label>
        <kendo-textbox formControlName="title"></kendo-textbox>
      </kendo-formfield>

      <kendo-formfield>
        <kendo-label for="absenceEmployee" [text]="t('employee') + ' *'"></kendo-label>
        <kendo-dropdownlist
          [data]="employees$ | async"
          [defaultItem]="defaultEmployee"
          textField="name"
          valueField="id"
          [valuePrimitive]="false"
          formControlName="employee"
          id="absenceEmployee"
        >
          <ng-template kendoDropDownListItemTemplate let-dataItem>
            {{ dataItem.firstName }} {{ dataItem.lastName }}
          </ng-template>
          <ng-template kendoDropDownListValueTemplate let-dataItem>
            {{ dataItem?.firstName }} {{ dataItem?.lastName }}
          </ng-template>
        </kendo-dropdownlist>
        <kendo-formerror>{{ t("isRequiredField") }}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield>
        <kendo-label [text]="t('absenceType') + ' *'"></kendo-label>
        <kendo-dropdownlist
          [data]="absenceTypes$ | async"
          [defaultItem]="defaultAbsence"
          textField="name"
          valueField="id"
          [valuePrimitive]="true"
          formControlName="absenceType"
        ></kendo-dropdownlist>
        <kendo-formerror>{{ t("isRequiredField") }}</kendo-formerror>
      </kendo-formfield>

      @if(flexTimeFallbackHours(tenantSettings$ | async); as fallbackHours){
        <div class="span2 warning">
          {{ t('overtimeFlexTimeFallbackHint', { hours: fallbackHours | number:'1.1-1' }) }}
        </div>
      }
    </form>

    <kendo-dialog-actions>
      <button kendoButton type="button" (click)="closeCreate()">
        {{ t("cancel") }}
      </button>
      <button
        kendoButton
        themeColor="primary"
        type="button"
        [disabled]="!createAbsenceForm.dirty || createAbsenceForm.invalid"
        (click)="onCreateAbsence()"
        loadingIndication="/AbsenceGroup/createAbsenceGroup"
      >
        {{ t("create") }}
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>
</ng-container>
